import { createSignal, onMount } from 'solid-js';
import IconBackTop from '~/assets/icons/backTop.svg';

const BackTop = () => {
  const [showBackTop, setShowBackTop] = createSignal(false);
  const [isAnimating, setIsAnimating] = createSignal(false);

  onMount(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const handleScroll = () => {
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
      setShowBackTop(true);
    } else {
      setShowBackTop(false);
    }
  };

  const scrollToTop = () => {
    if (isAnimating()) return;
    setIsAnimating(true);
    const start = window.scrollY;
    const duration = 500;
    let startTime: number | null = null;
    let currentScroll = start;

    function animateScroll(timestamp: number) {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const easeInOutQuad = (t: number) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
      const scrollY = easeInOutQuad(progress / duration) * start;
      if (progress < duration) {
        currentScroll = start - scrollY;
        window.scrollTo(0, currentScroll);
        requestAnimationFrame(animateScroll);
      } else {
        window.scrollTo(0, 0);
        setIsAnimating(false);
      }
    }

    if (currentScroll > 0) {
      requestAnimationFrame(animateScroll);
    }
  };

  onMount(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <div
      class="fixed bottom-6 right-6 z-50 flex size-[68px] animate-rocket-launch cursor-pointer items-center justify-center rounded-full bg-primary-color opacity-80 transition-all duration-300 hover:opacity-100"
      classList={{
        block: showBackTop(),
        hidden: !showBackTop(),
      }}
      onClick={scrollToTop}>
      <img src={IconBackTop} alt="IconBackTop" />
    </div>
  );
};

export default BackTop;
